import { render, staticRenderFns } from "./MedicalRequirementsPlanTestsAdd.vue?vue&type=template&id=328a1411&scoped=true&"
import script from "./MedicalRequirementsPlanTestsAdd.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlanTestsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328a1411",
  null
  
)

export default component.exports